module.exports = __webpack_public_path__ + "static/media/file_upload.b90d5eef.svg";